
    import {loadShare} from "@module-federation/runtime";
    const importMap = {
      
        "@apptimize/apptimize-web-sdk": async () => {
          let pkg = await import("__mf__virtual/vista__prebuild___mf_0_apptimize_mf_1_apptimize_mf_2_web_mf_2_sdk__prebuild__.js");
            return pkg;
        }
      ,
        "@fortawesome/fontawesome-svg-core": async () => {
          let pkg = await import("__mf__virtual/vista__prebuild___mf_0_fortawesome_mf_1_fontawesome_mf_2_svg_mf_2_core__prebuild__.js");
            return pkg;
        }
      ,
        "@fortawesome/react-fontawesome": async () => {
          let pkg = await import("__mf__virtual/vista__prebuild___mf_0_fortawesome_mf_1_react_mf_2_fontawesome__prebuild__.js");
            return pkg;
        }
      ,
        "@syf-api-library/account-features": async () => {
          let pkg = await import("__mf__virtual/vista__prebuild___mf_0_syf_mf_2_api_mf_2_library_mf_1_account_mf_2_features__prebuild__.js");
            return pkg;
        }
      ,
        "@syf-api-library/core": async () => {
          let pkg = await import("__mf__virtual/vista__prebuild___mf_0_syf_mf_2_api_mf_2_library_mf_1_core__prebuild__.js");
            return pkg;
        }
      ,
        "@syf-api-library/credit-accounts": async () => {
          let pkg = await import("__mf__virtual/vista__prebuild___mf_0_syf_mf_2_api_mf_2_library_mf_1_credit_mf_2_accounts__prebuild__.js");
            return pkg;
        }
      ,
        "@syf-cl/button": async () => {
          let pkg = await import("__mf__virtual/vista__prebuild___mf_0_syf_mf_2_cl_mf_1_button__prebuild__.js");
            return pkg;
        }
      ,
        "@syf-utils/analytics": async () => {
          let pkg = await import("__mf__virtual/vista__prebuild___mf_0_syf_mf_2_utils_mf_1_analytics__prebuild__.js");
            return pkg;
        }
      ,
        "@tanstack/react-query": async () => {
          let pkg = await import("__mf__virtual/vista__prebuild___mf_0_tanstack_mf_1_react_mf_2_query__prebuild__.js");
            return pkg;
        }
      ,
        "jotai": async () => {
          let pkg = await import("__mf__virtual/vista__prebuild__jotai__prebuild__.js");
            return pkg;
        }
      ,
        "react": async () => {
          let pkg = await import("__mf__virtual/vista__prebuild__react__prebuild__.js");
            return pkg;
        }
      ,
        "react-dom": async () => {
          let pkg = await import("__mf__virtual/vista__prebuild__react_mf_2_dom__prebuild__.js");
            return pkg;
        }
      ,
        "react-router-dom": async () => {
          let pkg = await import("__mf__virtual/vista__prebuild__react_mf_2_router_mf_2_dom__prebuild__.js");
            return pkg;
        }
      ,
        "recharts": async () => {
          let pkg = await import("__mf__virtual/vista__prebuild__recharts__prebuild__.js");
            return pkg;
        }
      
    }
      const usedShared = {
      
          "@apptimize/apptimize-web-sdk": {
            name: "@apptimize/apptimize-web-sdk",
            version: "1.2.44",
            scope: ["default"],
            loaded: false,
            from: "vista",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"@apptimize/apptimize-web-sdk"}' must be provided by host`);
              }
              usedShared["@apptimize/apptimize-web-sdk"].loaded = true
              const {"@apptimize/apptimize-web-sdk": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "^1.2.44",
              
            }
          }
        ,
          "@fortawesome/fontawesome-svg-core": {
            name: "@fortawesome/fontawesome-svg-core",
            version: "6.1.1",
            scope: ["default"],
            loaded: false,
            from: "vista",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"@fortawesome/fontawesome-svg-core"}' must be provided by host`);
              }
              usedShared["@fortawesome/fontawesome-svg-core"].loaded = true
              const {"@fortawesome/fontawesome-svg-core": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: false,
              requiredVersion: "6.1.1",
              
            }
          }
        ,
          "@fortawesome/react-fontawesome": {
            name: "@fortawesome/react-fontawesome",
            version: "0.2.0",
            scope: ["default"],
            loaded: false,
            from: "vista",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"@fortawesome/react-fontawesome"}' must be provided by host`);
              }
              usedShared["@fortawesome/react-fontawesome"].loaded = true
              const {"@fortawesome/react-fontawesome": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: false,
              requiredVersion: "^0.2.0",
              
            }
          }
        ,
          "@syf-api-library/account-features": {
            name: "@syf-api-library/account-features",
            version: "1.0.2",
            scope: ["default"],
            loaded: false,
            from: "vista",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"@syf-api-library/account-features"}' must be provided by host`);
              }
              usedShared["@syf-api-library/account-features"].loaded = true
              const {"@syf-api-library/account-features": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "1.0.2",
              
            }
          }
        ,
          "@syf-api-library/core": {
            name: "@syf-api-library/core",
            version: "1.0.2",
            scope: ["default"],
            loaded: false,
            from: "vista",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"@syf-api-library/core"}' must be provided by host`);
              }
              usedShared["@syf-api-library/core"].loaded = true
              const {"@syf-api-library/core": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "1.0.2",
              
            }
          }
        ,
          "@syf-api-library/credit-accounts": {
            name: "@syf-api-library/credit-accounts",
            version: "1.0.2",
            scope: ["default"],
            loaded: false,
            from: "vista",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"@syf-api-library/credit-accounts"}' must be provided by host`);
              }
              usedShared["@syf-api-library/credit-accounts"].loaded = true
              const {"@syf-api-library/credit-accounts": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "1.0.2",
              
            }
          }
        ,
          "@syf-cl/button": {
            name: "@syf-cl/button",
            version: "1.0.1",
            scope: ["default"],
            loaded: false,
            from: "vista",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"@syf-cl/button"}' must be provided by host`);
              }
              usedShared["@syf-cl/button"].loaded = true
              const {"@syf-cl/button": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "1.0.1",
              
            }
          }
        ,
          "@syf-utils/analytics": {
            name: "@syf-utils/analytics",
            version: "1.1.0",
            scope: ["default"],
            loaded: false,
            from: "vista",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"@syf-utils/analytics"}' must be provided by host`);
              }
              usedShared["@syf-utils/analytics"].loaded = true
              const {"@syf-utils/analytics": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "1.1.0",
              
            }
          }
        ,
          "@tanstack/react-query": {
            name: "@tanstack/react-query",
            version: "4.36.1",
            scope: ["default"],
            loaded: false,
            from: "vista",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"@tanstack/react-query"}' must be provided by host`);
              }
              usedShared["@tanstack/react-query"].loaded = true
              const {"@tanstack/react-query": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "4.36.1",
              
            }
          }
        ,
          "jotai": {
            name: "jotai",
            version: "2.17.1",
            scope: ["default"],
            loaded: false,
            from: "vista",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"jotai"}' must be provided by host`);
              }
              usedShared["jotai"].loaded = true
              const {"jotai": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "^2.12.5",
              
            }
          }
        ,
          "react": {
            name: "react",
            version: "18.2.0",
            scope: ["default"],
            loaded: false,
            from: "vista",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"react"}' must be provided by host`);
              }
              usedShared["react"].loaded = true
              const {"react": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "18.2.0",
              
            }
          }
        ,
          "react-dom": {
            name: "react-dom",
            version: "18.2.0",
            scope: ["default"],
            loaded: false,
            from: "vista",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"react-dom"}' must be provided by host`);
              }
              usedShared["react-dom"].loaded = true
              const {"react-dom": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "18.2.0",
              
            }
          }
        ,
          "react-router-dom": {
            name: "react-router-dom",
            version: "6.9.0",
            scope: ["default"],
            loaded: false,
            from: "vista",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"react-router-dom"}' must be provided by host`);
              }
              usedShared["react-router-dom"].loaded = true
              const {"react-router-dom": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: true,
              requiredVersion: "6.9.0",
              
            }
          }
        ,
          "recharts": {
            name: "recharts",
            version: "2.15.1",
            scope: ["default"],
            loaded: false,
            from: "vista",
            async get () {
              if (false) {
                throw new Error(`Shared module '${"recharts"}' must be provided by host`);
              }
              usedShared["recharts"].loaded = true
              const {"recharts": pkgDynamicImport} = importMap
              const res = await pkgDynamicImport()
              const exportModule = {...res}
              // All npm packages pre-built by vite will be converted to esm
              Object.defineProperty(exportModule, "__esModule", {
                value: true,
                enumerable: false
              })
              return function () {
                return exportModule
              }
            },
            shareConfig: {
              singleton: false,
              requiredVersion: "^2.15.1",
              
            }
          }
        
    }
      const usedRemotes = [
                {
                  entryGlobalName: "vantage-mfe-runtime",
                  name: "vantage-mfe-runtime",
                  type: "module",
                  entry: "CF_VANTAGE_REMOTE_URL",
                  shareScope: "default",
                }
          ,
                {
                  entryGlobalName: "statements-mfe-runtime",
                  name: "statements-mfe-runtime",
                  type: "module",
                  entry: "CF_STATEMENTS_REMOTE_URL",
                  shareScope: "default",
                }
          ,
                {
                  entryGlobalName: "profile-mfe-runtime-income",
                  name: "profile-mfe-runtime-income",
                  type: "module",
                  entry: "CF_PROFILE_REMOTE_URL",
                  shareScope: "default",
                }
          ,
                {
                  entryGlobalName: "make-payment-mfe",
                  name: "make-payment-mfe",
                  type: "module",
                  entry: "CF_MAKE_A_PAYMENT_REMOTE_URL",
                  shareScope: "default",
                }
          
      ]
      export {
        usedShared,
        usedRemotes
      }
      